import { EventEmitter } from '@angular/core';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { WebUtils } from '../../../../utils/web.utils';
import { UserService } from '../../../../services/user.service';
import { UserDetails } from '../../../../../models/user';
import { AchooPopupComponent } from '../../../../core/achoo-popup/achoo-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../../../services/modal/modal.service';
import { EventTrackerService, UserActionType, Page, TargetType } from '../../../../services/event-tracker/event-tracker.service';
import { CommonConstant } from '../../../../app.constants';
import { ObjectUtils } from '../../../../utils/object.utils';
import * as Sentry from '@sentry/browser';
var UserDetailsComponent = /** @class */ (function () {
    function UserDetailsComponent(campaignService, userService, modalService, translate, eventTracker) {
        this.campaignService = campaignService;
        this.userService = userService;
        this.modalService = modalService;
        this.translate = translate;
        this.eventTracker = eventTracker;
        this.currentUserDetails = new UserDetails();
        this.submitUserDetails = new EventEmitter();
        this.hasChangedImage = false;
        this.isUploadImgSuccess = false;
    }
    UserDetailsComponent.prototype.validateEmail = function (emailFormControl) {
        if (!emailFormControl) {
            return null;
        }
        if (!WebUtils.validateEmail(emailFormControl.value)) {
            return {
                invalidEmail: true
            };
        }
        return null;
    };
    UserDetailsComponent.prototype.ngOnInit = function () {
        this.userDetails = new FormGroup({
            'firstName': new FormControl(this.currentUserDetails.firstName, [Validators.required]),
            'lastName': new FormControl(this.currentUserDetails.lastName, [Validators.required]),
            'email': new FormControl(this.currentUserDetails.email, [Validators.required, this.validateEmail.bind(this)]),
            'phoneNumber': new FormControl(this.currentUserDetails.phone, [Validators.required])
        });
        this.getProfileImage();
    };
    Object.defineProperty(UserDetailsComponent.prototype, "firstName", {
        get: function () {
            return this.userDetails.get('firstName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserDetailsComponent.prototype, "lastName", {
        get: function () {
            return this.userDetails.get('lastName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserDetailsComponent.prototype, "email", {
        get: function () {
            return this.userDetails.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserDetailsComponent.prototype, "phoneNumber", {
        get: function () {
            return this.userDetails.get('phoneNumber');
        },
        enumerable: true,
        configurable: true
    });
    UserDetailsComponent.prototype.onSubmitUserDetails = function () {
        if (!this.userDetails.valid) {
            return;
        }
        this.saveUserDetailsData();
    };
    UserDetailsComponent.prototype.saveUserDetailsData = function () {
        var _this = this;
        if (!this.userData) {
            return;
        }
        // prepare data for sending to ws
        var userProfileData = {
            firstName: this.userDetails.value.firstName,
            lastName: this.userDetails.value.lastName,
            email: this.userDetails.value.email,
            phone: this.userDetails.value.phoneNumber,
            image: this.currentUserDetails.image
        };
        this.userService.updateProfile(userProfileData).subscribe(function (res) {
            _this.handleNotificationTitle(true);
            _this.msgString = _this.translate.instant('account_settings.notification_msg.update_user_details_success');
            _this.modalService.closeSinglePopup(_this._userDetailNotificationPopupRef);
            _this._userDetailNotificationPopupRef = _this.modalService.openMultipleModal(_this.userDetailNotificationPopup, null);
            _this.sendMixpanelEvents(false);
        }, function (err) {
            // rollback the user avatar to the previous image
            _this.userService.updateCurrentUserAvatar(_this.previousUserAvatar, _this.userData);
            _this.uploadedImage = _this.userData.data && _this.userData.data.image;
            _this.handleNotificationTitle(false);
            if (_this.isUpdatePasswordSuccess && _this.isUploadImgSuccess) {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.update_pwd_and_img_success_but_details_failed');
            }
            else {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.update_failed');
            }
            _this.modalService.closeSinglePopup(_this._userDetailNotificationPopupRef);
            _this._userDetailNotificationPopupRef = _this.modalService.openMultipleModal(_this.userDetailNotificationPopup, null);
            Sentry.captureException(new Error('Failed to update user profile'));
        });
    };
    UserDetailsComponent.prototype.onProfilePictureSelected = function (evt) {
        var _this = this;
        if (!evt || !evt.target || !evt.target.files) {
            return;
        }
        this.hasChangedImage = true;
        var selectedImageList = (evt.target.files);
        if (!selectedImageList || selectedImageList.length === 0) {
            return;
        }
        this.selectedImage = selectedImageList[0];
        if (this.selectedImage.size / 1024 > CommonConstant.MAX_PROFILE_PICTURE_SIZE) {
            this.handleNotificationTitle(false);
            this.msgString = this.translate.instant('account_settings.notification_msg.large_img');
            this.modalService.closeSinglePopup(this._userDetailNotificationPopupRef);
            this._userDetailNotificationPopupRef = this.modalService.open(this.userDetailNotificationPopup, null, true);
            return;
        }
        var file = this.selectedImage;
        var fileReader = new FileReader();
        fileReader.onloadend = function (e) {
            _this.uploadedImage = fileReader.result;
        };
        fileReader.readAsDataURL(file);
    };
    UserDetailsComponent.prototype.uploadProfilePicture = function (image) {
        var _this = this;
        // Only upload one file on each select
        var formData = new FormData();
        formData.append('file', image);
        this.imageInput.nativeElement.value = '';
        this.previousUserAvatar = this.currentUserDetails.image;
        this.campaignService.uploadFile(formData).subscribe(function (data) {
            if (data) {
                _this.currentUserDetails.image = data.diskFileName;
                _this.isUploadImgSuccess = true;
                // Immediately show the new user avatar in UI
                _this.userService.updateCurrentUserAvatar(_this.currentUserDetails.image, _this.userData);
                _this.onSubmitUserDetails();
                _this.sendMixpanelEvents(true);
            }
        }, function (error) {
            _this.hasChangedImage = false;
            _this.isUploadImgSuccess = false;
            // rollback the user avatar to the previous image
            _this.userService.updateCurrentUserAvatar(_this.previousUserAvatar, _this.userData);
            _this.uploadedImage = _this.userData.data && _this.userData.data.image || _this.currentUserDetails.image;
            _this.handleNotificationTitle(false);
            if (_this.isUpdatePasswordSuccess) {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.update_pwd_success_and_img_failed');
            }
            else {
                _this.msgString = _this.translate.instant('account_settings.notification_msg.upload_image_fail');
            }
            _this.modalService.closeSinglePopup(_this._userDetailNotificationPopupRef);
            _this._userDetailNotificationPopupRef = _this.modalService.open(_this.userDetailNotificationPopup, null, true);
            Sentry.captureException(new Error('Upload failed on Settings page'));
        });
    };
    UserDetailsComponent.prototype.getProfileImage = function () {
        this.userData = ObjectUtils.parseJSON(localStorage.getItem('user'));
        if (this.currentUserDetails.image) {
            this.uploadedImage = this.currentUserDetails.image;
        }
        else if (this.userData && this.userData.data && this.userData.data.image) {
            this.uploadedImage = this.userData.data.image;
        }
        else {
            this.uploadedImage = null;
        }
    };
    UserDetailsComponent.prototype.sendMixpanelEvents = function (isUploadImage) {
        if (isUploadImage) {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.IMAGE, {
                id: this.currentUserDetails.id,
                name: this.currentUserDetails.firstName,
                type: TargetType.PROFILE_IMAGE
            }, {
                action: UserActionType.UPLOAD,
            }, undefined, null, null);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROFILE, {
                id: this.userDetails.value.id,
                name: this.userDetails.value.firstName + ' ' + this.userDetails.value.lastName,
                type: TargetType.USER
            }, {
                action: UserActionType.UPDATE,
            }, undefined, null, null);
        }
    };
    UserDetailsComponent.prototype.handleNotificationTitle = function (isSuccess) {
        this.popupTitle = !isSuccess ? this.translate.instant('notification.error') : this.translate.instant('notification.success');
    };
    return UserDetailsComponent;
}());
export { UserDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-details/user-details.component.ts.pre-build-optimizer.js